import classnames from 'classnames';

import style from './TextLink.module.scss';

export enum LinkTarget {
    SELF = '_self',
    BLANK = '_blank',
}
export interface TextLinkProps {
    link?: string;
    label: React.ReactNode;
    isHighlighted?: boolean;
    target?: LinkTarget;
    className?: string;
    modifiers?: TextLinkModifiers[];
}

export enum TextLinkModifiers {
    // @ts-ignore
    Highlighted = style.highlighted,
}

interface Props extends TextLinkProps {}

export function TextLink({ link, label, isHighlighted, className, target = LinkTarget.BLANK, modifiers = [] }: Props) {
    return (
        <a
            className={classnames([
                style.root,
                ...modifiers,
                !!className && className,
                isHighlighted && style.root_highlighted,
            ])}
            href={link}
            target={target}
        >
            {label}
        </a>
    );
}
